export default __webpack_public_path__ + "static/media/Logo.dd2af56e.png";